exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".menuCreateProcess{height:100%;position:fixed;background:#fff;z-index:251;top:0;right:0;overflow:scroll;border-radius:0 0 0 0!important}@media screen and (max-width:768px){.menuCreateProcess{width:100%}}@media screen and (min-width:1280px){.menuCreateProcess{width:30%}}@media screen and (max-width:768px){.menuCreateProcess .actions-footer{width:100%}}@media screen and (min-width:1280px){.menuCreateProcess .actions-footer{width:30%}}.menuCreateProcess .field{margin-bottom:0}.option-benchmark{display:flex;flex-direction:column;justify-content:center;align-items:center;margin-top:20px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-4311e347","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/lideres/components/menuCreateProcess.vue
// module id = 1154
// module chunks = 2